import $ from 'jquery';
import React from "react";
import PropTypes from 'prop-types';
import ProjectScope from "./projectScope/projectScope";
import ProjectScopeSteps from "./projectScope/projectScopeSteps";
import ProjectScopeStones from "./projectScope/projectScopeStones";
import * as Misc from "./../misc";
import IntroVideo from './../components/common/introVideo';
import Analytics from './../analytics';

export default class ScopeView extends React.Component{
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  constructor (props) {
    super(props);

    this.state = {
      currentIntroVideo: null,
      isMounted: false
    };
  }

  componentDidMount () {
    $(document).on('stopVideos', () => {
      this.handleClickWhenIntroVideo();
    });

    const router = this.context.router;
    const route = this.props.route;
    router.setRouteLeaveHook(route, this.routeWillLeave);
    this.setState({isMounted: true})
  }

  componentWillUnmount () {
    this.handleClickWhenIntroVideo();
    $(document).off('click', this.handleClickWhenIntroVideo);
    this.setState({isMounted: false})
  };

  subscribeToDocumentClick= (video) => {
    this.state.currentIntroVideo = video;
    $(document)
      .off('click', this.handleClickWhenIntroVideo)
      .on('click', this.handleClickWhenIntroVideo);
  };

  handleClickWhenIntroVideo=() =>{
    if (this.state.currentIntroVideo) {
      Analytics.sendClickEvent('scope-hide-video');
      Misc.hideVideo(this.state.currentIntroVideo);
      this.state.currentIntroVideo = null;
      Analytics.sendClickEvent('intro-video');
      $(document).off('click', this.handleClickWhenIntroVideo);
    }
  };

  handleShowSqFtCalc= () =>{
    if (!ProjectScope.shownIntroVideos('sqftCalc')) {
      Misc.playVideo('#sqftCalc');
      ProjectScope.setShownIntroVideos('sqftCalc', true);
      this.state.currentIntroVideo = '#sqftCalc';
      this.subscribeToDocumentClick();
    }
  };

  render () {

    const isMobile = (window.innerWidth <= 768);

    return (
      <div className="project-scope-section-wrapper">
        <div className="project-scope-steps">
          <ProjectScopeSteps goToNextView={this.props.goToNextView} showSqFtCalc={this.handleShowSqFtCalc}
                             openKitchenVisualizerIframe={this.props.openKitchenVisualizerIframe}/>
        </div>
        <IntroVideo type="sqftCalc"/>
          {this.state.isMounted && !isMobile ? (
            <div className="project-scope-stones-wrapper">
              <h2 className="project-scope-title">View All Stones</h2>
              <div className="project-scope-stones">
                <ProjectScopeStones/>
              </div>
            </div>
          ) : null}
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/scopeView.js